import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";

import { Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, Typography, Paper } from "@mui/material";
import axios from "axios";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { t } from "i18next";
import { GetNameChoose } from "../../funcUtils";
import XoSoHeaderNav from "../../components/XoSoHeaderNav";

function SetXoSo() {
    const [list30, setList30] = useState();
    const [bet, setBet] = useState(null);
    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    const [second, setSecond] = useState(15);
    const [minute, setMinute] = useState(1);
    const [start, setStart] = useState(false);
    const [dulieunhap, setDulieunhap] = useState(new Date());
    const [update, setUpdate] = useState(0);
    const [current, setCurrent] = useState(null);
    const date = new Date();
    const currentMinute = date.getMinutes();
    const currentSecond = date.getSeconds();

    const [total, setTotal] = useState(null);

    const [chimMoiList, setChimMoiList] = useState([]);

    function formatDateTimeFull(dateStr) {
        if (!dateStr) return "";
        const m = new Date(dateStr);
        if (isNaN(m.getTime())) return "";
        return (
            ("0" + m.getDate()).slice(-2) + "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
            m.getFullYear() + " " +
            ("0" + m.getHours()).slice(-2) + ":" +
            ("0" + m.getMinutes()).slice(-2) + ":" +
            ("0" + m.getSeconds()).slice(-2)
        );
    }

    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const fetchChimMoiList = () => {
        const codeChimMoi = `xs75s`; 
        axios.get(`${process.env.REACT_APP_API_URL}/auth/chimmoi?code=${codeChimMoi}`)
            .then(res => {
                if (res.data && res.data.data) {
                    setChimMoiList(res.data.data);
                }
            })
            .catch(err => {
                console.log("Không lấy được danh sách chim mồi", err);
                setChimMoiList([]);
            });
    };

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getadmin`).then((res) => {
            setBet(res.data.data[0]);
            setDulieunhap(new Date(res.data.data[0].createdAt));
            setStart(true);
        });
        axios
            .get(`${process.env.REACT_APP_API_URL}/xs75s/getallbet`, {})
            .then((res) => {
                setTotal(res.data.data);
            })
            .catch(() => setTotal(null));
        axios
            .get(`${process.env.REACT_APP_API_URL}/xs75s/list30bet`, {})
            .then((res) => {
                setList30(res.data.data);
            })
            .catch(() => setList30(null));
        axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getcurrent`, {}).then((res) => {
            setCurrent(res.data.data);
        });

        fetchChimMoiList();
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            if (Math.floor(75 - (new Date() - dulieunhap) / 1000) < 0) {
                axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getadmin`).then((res) => {
                    setBet(res.data.data[0]);
                    setDulieunhap(new Date(res.data.data[0].createdAt));
                });
                axios
                    .get(`${process.env.REACT_APP_API_URL}/xs75s/getallbet`, {})
                    .then((res) => {
                        setTotal(res.data.data);
                    })
                    .catch(() => setTotal(null));
                axios
                    .get(`${process.env.REACT_APP_API_URL}/xs75s/list30bet`, {})
                    .then((res) => {
                        setList30(res.data.data);
                    })
                    .catch(() => setList30(null));

                axios.get(`${process.env.REACT_APP_API_URL}/xs75s/getcurrent`).then((res) => {
                    setCurrent(res.data.data);
                });
            }
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, [dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(75 - (date - dulieunhap) / 1000);
        let myTimeout;

        if (currentMinute === dulieunhap.getMinutes() && currentSecond === dulieunhap.getSeconds()) {
            setStart(true);
            setSecond(second - 1);
            return () => {
                clearTimeout(myTimeout);
            };
        } else if (curTime_second < 75 && curTime_second >= 0) {
            setSecond(curTime_second % 60);
            setMinute((curTime_second - (curTime_second % 60)) / 60);
            setStart(true);
            return () => {
                clearTimeout(myTimeout);
            };
        } else {
            myTimeout = setTimeout(() => {
                setUpdate(update + 1);
            }, 500);
        }
    }, [update, dulieunhap]);

    useEffect(() => {
        let curTime_second = Math.floor(75 - (date - dulieunhap) / 1000);
        let myTimeout = 0;
        if (start) {
            setSecond(curTime_second % 60);
            setMinute(Math.floor(curTime_second / 60));
            if (curTime_second > 75 || curTime_second <= 0) {
                setStart(false);
                setMinute(1);
                setSecond(15);
                return () => {
                    clearTimeout(myTimeout);
                };
            }
            myTimeout = setTimeout(() => {
                setSecond(second - 1);
                axios
                    .get(`${process.env.REACT_APP_API_URL}/xs75s/getcurrent`)
                    .then((res) => {
                        setCurrent(res.data.data);
                    })
                    .catch(() => setCurrent(null));
            }, 1000);
        }
        return () => {
            clearTimeout(myTimeout);
        };
    }, [second, start, dulieunhap]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = {
            id_bet: bet._id,
            dacbiet: e.target.dacbiet.value,
            nhat: e.target.nhat.value,
            hai: e.target.hai1.value + " " + e.target.hai2.value,
            ba: e.target.ba1.value + " " + e.target.ba4.value + " " + e.target.ba2.value + " " + e.target.ba3.value + " " + e.target.ba5.value + " " + e.target.ba6.value,
            tu: e.target.tu1.value + " " + e.target.tu2.value + " " + e.target.tu3.value + " " + e.target.tu4.value,
            sau: e.target.sau1.value + " " + e.target.sau2.value + " " + e.target.sau3.value,
            bay: e.target.bay1.value + " " + e.target.bay2.value + " " + e.target.bay3.value + " " + e.target.bay4.value,
            nam: e.target.nam1.value + " " + e.target.nam2.value + " " + e.target.nam3.value + " " + e.target.nam4.value + " " + e.target.nam5.value + " " + e.target.nam6.value
        };
        axios
            .post(`${process.env.REACT_APP_API_URL}/xs75s/update`, formData)
            .then((res) => {
                setBet(res.data.data);
                swal(t('success'), "", "success").then(() => {
                    window.location.reload();
                });
            })
            .catch((res) => swal(t('error'), "", "error"));
    };

    const [listEdit, setListEdit] = useState();
    const [newChange, setNewChange] = useState();
    const handleChange = (e) => {
        setListEdit(e.target.value);
        const a = list30.find((item) => item?.id_bet === e.target.value);
        setNewChange(a);
    };

    const [numbers, setNumbers] = useState(Array(27).fill(null));
    const generateRandomNumbers = () => {
        const randomNumbers = Array(27)
            .fill("")
            .map((_, index) => {
                let randomNumber;
                if (index < 10) {
                    randomNumber = Math.floor(Math.random() * 90000) + 10000;
                } else if (index >= 10 && index < 20) {
                    randomNumber = Math.floor(Math.random() * 9000) + 1000;
                } else if (index >= 20 && index < 23) {
                    randomNumber = Math.floor(Math.random() * 900) + 100;
                } else {
                    randomNumber = Math.floor(Math.random() * 90) + 10;
                }
                return randomNumber.toString();
            });
        setNumbers(randomNumbers);
    };

    const handleInputChange = (event, index) => {
        const newValue = event.target.value;
        setNumbers((prevInputValues) => {
            const newInputValues = [...prevInputValues];
            newInputValues[index] = newValue;
            return newInputValues;
        });
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <DashboardLayout>
                    {profile?.permission?.set == 1 ? (
                        <Box
                            component="main"
                            sx={{
                                flexGrow: 1,
                                py: 1
                            }}>
                            <Container maxWidth={false}>
                                <XoSoHeaderNav currentMode="xs75s" />

                                <div className="container_set">QUẢN TRỊ XỔ SỐ - XS 75s</div>

                                <div className="cycle_bet">
                                    {bet ? (
                                        <span style={{ color: "black" }} className="info_bet">
                                            {t('session')} {bet.id_bet}
                                        </span>
                                    ) : (
                                        <span>{t('waiting')}</span>
                                    )}
                                    <div style={{ color: "black" }} className="count">
                                        {minute} : {second < 10 ? "0" : ""}
                                        {second}
                                    </div>
                                </div>

                                <Paper elevation={3} sx={{ mt: 4, mb: 4, borderRadius: 2, overflow: 'hidden' }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ bgcolor: '#fff3e0' }}>
                                                <TableCell style={{ fontWeight: 'bold', width: '10%' }}>STT</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '20%' }}>ID User</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '40%' }}>Tài Khoản</TableCell>
                                                <TableCell style={{ fontWeight: 'bold', width: '30%' }}>Mã Lệnh Đang Ép</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {chimMoiList && chimMoiList.length > 0 ? (
                                                chimMoiList.map((item, idx) => (
                                                    <TableRow key={idx} hover>
                                                        <TableCell style={{ fontWeight: 'bold' }}>{idx + 1}</TableCell>
                                                        <TableCell>{item.iduser}</TableCell>
                                                        <TableCell style={{ color: '#1976d2', fontWeight: 'bold' }}>{item.username}</TableCell>
                                                        <TableCell style={{ color: 'red', fontWeight: 'bold' }}>{item.win}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                    <TableCell colSpan={4}>Không có Chim Mồi nào được cài ở sảnh này.</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Paper>

                                <div className="form_set" style={{ marginTop: '20px' }}>
                                    <Box>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: 'bold' }}>ID</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>{t('username')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>{t('selected')}</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Số điểm</TableCell>
                                                    <TableCell style={{ fontWeight: 'bold' }}>Thời gian cược</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {current && current.length > 0 ? (
                                                    current.map((item, idx) => (
                                                        <TableRow key={idx} hover>
                                                            <TableCell>{item?.user?.iduser}</TableCell>
                                                            <TableCell sx={{ fontWeight: 'bold', color: '#1976d2' }}>{item?.user?.username}</TableCell>
                                                            <TableCell>
                                                                <span style={{ color: "#d32f2f", fontWeight: "bold" }}>
                                                                    {GetNameChoose(item.state, item.type)}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>
                                                                <span style={{ color: "#2e7d32", fontWeight: "bold" }}>
                                                                    {Math.floor(Number(item.money || 0) / 1000).toLocaleString("vi-VN")}
                                                                </span>
                                                            </TableCell>
                                                            <TableCell>{formatDateTimeFull(item.createdAt)}</TableCell>
                                                        </TableRow>
                                                    ))
                                                ) : (
                                                    <TableRow style={{ textAlign: "center", color: "#aaa" }}>
                                                        <TableCell colSpan={5}>{t('no_player')}</TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </Box>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div style={{ color: "black", marginTop: '20px' }} className="result_admin_choose">
                                        {bet ? (
                                            <table id="table-xsmb" className="table-result table table-bordered table-striped table-xsmb">
                                                <tbody>
                                                    <tr>
                                                        <th style={{ width: "10%" }}>ĐB</th>
                                                        <td>
                                                            <span id="mb_prize_0" className="special-prize div-horizontal">
                                                                <input
                                                                    defaultValue={bet.dacbiet} min="10000" max="99999" name="dacbiet" style={{ width: "60px" }}
                                                                    value={numbers[0] == null ? bet.dacbiet : numbers[0]} onChange={(e) => handleInputChange(e, 0)}
                                                                />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>1</th>
                                                        <td>
                                                            <span id="mb_prize_1" className="prize1 div-horizontal">
                                                                <input 
                                                                    defaultValue={bet.nhat} name="nhat" min="10000" max="99999" style={{ width: "60px" }} 
                                                                    value={numbers[1] == null ? bet.nhat : numbers[1]} onChange={(e) => handleInputChange(e, 1)}
                                                                />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>2</th>
                                                        <td>
                                                            <span id="mb_prize_2" className="prize2 div-horizontal">
                                                                <input defaultValue={bet.hai.split(" ")[0]} name="hai1" min="10000" max="99999" style={{ width: "60px" }} value={numbers[2] == null ? bet.hai.split(" ")[0] : numbers[2]} onChange={(e) => handleInputChange(e, 2)} />
                                                            </span>
                                                            <span id="mb_prize_3" className="prize2 div-horizontal">
                                                                <input defaultValue={bet.hai.split(" ")[1]} name="hai2" min="10000" max="99999" style={{ width: "60px" }} value={numbers[3] == null ? bet.hai.split(" ")[1] : numbers[3]} onChange={(e) => handleInputChange(e, 3)} />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>3</th>
                                                        <td>
                                                            <span id="mb_prize_4" className="prize3 div-horizontal">
                                                                <input defaultValue={bet.ba.split(" ")[0]} min="10000" max="99999" name="ba1" style={{ width: "60px" }} value={numbers[4] == null ? bet.ba.split(" ")[0] : numbers[4]} onChange={(e) => handleInputChange(e, 4)} />
                                                            </span>
                                                            <span id="mb_prize_5" className="prize3 div-horizontal">
                                                                <input defaultValue={bet.ba.split(" ")[1]} min="10000" max="99999" name="ba2" style={{ width: "60px" }} value={numbers[5] == null ? bet.ba.split(" ")[1] : numbers[5]} onChange={(e) => handleInputChange(e, 5)} />
                                                            </span>
                                                            <span id="mb_prize_6" className="prize3 div-horizontal">
                                                                <input defaultValue={bet.ba.split(" ")[2]} min="10000" max="99999" name="ba3" style={{ width: "60px" }} value={numbers[6] == null ? bet.ba.split(" ")[2] : numbers[6]} onChange={(e) => handleInputChange(e, 6)} />
                                                            </span>
                                                            <span id="mb_prize_7" className="prize3 div-horizontal">
                                                                <input defaultValue={bet.ba.split(" ")[3]} min="10000" max="99999" name="ba4" style={{ width: "60px" }} value={numbers[7] == null ? bet.ba.split(" ")[3] : numbers[7]} onChange={(e) => handleInputChange(e, 7)} />
                                                            </span>
                                                            <span id="mb_prize_8" className="prize3 div-horizontal">
                                                                <input defaultValue={bet.ba.split(" ")[4]} min="10000" max="99999" name="ba5" style={{ width: "60px" }} value={numbers[8] == null ? bet.ba.split(" ")[4] : numbers[8]} onChange={(e) => handleInputChange(e, 8)} />
                                                            </span>
                                                            <span id="mb_prize_9" className="prize3 div-horizontal">
                                                                <input defaultValue={bet.ba.split(" ")[5]} min="10000" max="99999" name="ba6" style={{ width: "60px" }} value={numbers[9] == null ? bet.ba.split(" ")[5] : numbers[9]} onChange={(e) => handleInputChange(e, 9)} />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>4</th>
                                                        <td>
                                                            <span id="mb_prize_10" className="prize4 div-horizontal">
                                                                <input defaultValue={bet.tu.split(" ")[0]} min="1000" max="9999" name="tu1" style={{ width: "60px" }} value={numbers[10] == null ? bet.tu.split(" ")[0] : numbers[10]} onChange={(e) => handleInputChange(e, 10)} />
                                                            </span>
                                                            <span id="mb_prize_11" className="prize4 div-horizontal">
                                                                <input defaultValue={bet.tu.split(" ")[1]} min="1000" max="9999" name="tu2" style={{ width: "60px" }} value={numbers[11] == null ? bet.tu.split(" ")[1] : numbers[11]} onChange={(e) => handleInputChange(e, 11)} />
                                                            </span>
                                                            <span id="mb_prize_12" className="prize4 div-horizontal">
                                                                <input defaultValue={bet.tu.split(" ")[2]} min="1000" max="9999" name="tu3" style={{ width: "60px" }} value={numbers[12] == null ? bet.tu.split(" ")[2] : numbers[12]} onChange={(e) => handleInputChange(e, 12)} />
                                                            </span>
                                                            <span id="mb_prize_13" className="prize4 div-horizontal">
                                                                <input defaultValue={bet.tu.split(" ")[3]} min="1000" max="9999" name="tu4" style={{ width: "60px" }} value={numbers[13] == null ? bet.tu.split(" ")[3] : numbers[13]} onChange={(e) => handleInputChange(e, 13)} />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>5</th>
                                                        <td>
                                                            <span id="mb_prize_14" className="prize5 div-horizontal">
                                                                <input defaultValue={bet.nam.split(" ")[0]} min="1000" max="9999" name="nam1" style={{ width: "60px" }} value={numbers[14] == null ? bet.nam.split(" ")[0] : numbers[14]} onChange={(e) => handleInputChange(e, 14)} />
                                                            </span>
                                                            <span id="mb_prize_15" className="prize5 div-horizontal">
                                                                <input defaultValue={bet.nam.split(" ")[1]} min="1000" max="9999" name="nam2" style={{ width: "60px" }} value={numbers[15] == null ? bet.nam.split(" ")[1] : numbers[15]} onChange={(e) => handleInputChange(e, 15)} />
                                                            </span>
                                                            <span id="mb_prize_16" className="prize5 div-horizontal">
                                                                <input defaultValue={bet.nam.split(" ")[2]} min="1000" max="9999" name="nam6" style={{ width: "60px" }} value={numbers[16] == null ? bet.nam.split(" ")[2] : numbers[16]} onChange={(e) => handleInputChange(e, 16)} />
                                                            </span>
                                                            <span id="mb_prize_17" className="prize5 div-horizontal">
                                                                <input defaultValue={bet.nam.split(" ")[3]} min="1000" max="9999" name="nam3" style={{ width: "60px" }} value={numbers[17] == null ? bet.nam.split(" ")[3] : numbers[17]} onChange={(e) => handleInputChange(e, 17)} />
                                                            </span>
                                                            <span id="mb_prize_18" className="prize5 div-horizontal">
                                                                <input defaultValue={bet.nam.split(" ")[4]} min="1000" max="9999" name="nam4" style={{ width: "60px" }} value={numbers[18] == null ? bet.nam.split(" ")[4] : numbers[18]} onChange={(e) => handleInputChange(e, 18)} />
                                                            </span>
                                                            <span id="mb_prize_19" className="prize5 div-horizontal">
                                                                <input defaultValue={bet.nam.split(" ")[5]} min="1000" max="9999" name="nam5" style={{ width: "60px" }} value={numbers[19] == null ? bet.nam.split(" ")[5] : numbers[19]} onChange={(e) => handleInputChange(e, 19)} />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>6</th>
                                                        <td>
                                                            <span id="mb_prize_20" className="prize6 div-horizontal">
                                                                <input defaultValue={bet.sau.split(" ")[0]} min="100" max="999" name="sau1" style={{ width: "60px" }} value={numbers[20] == null ? bet.sau.split(" ")[0] : numbers[20]} onChange={(e) => handleInputChange(e, 20)} />
                                                            </span>
                                                            <span id="mb_prize_21" className="prize6 div-horizontal">
                                                                <input defaultValue={bet.sau.split(" ")[1]} min="100" max="999" name="sau2" style={{ width: "60px" }} value={numbers[21] == null ? bet.sau.split(" ")[1] : numbers[21]} onChange={(e) => handleInputChange(e, 21)} />
                                                            </span>
                                                            <span id="mb_prize_22" className="prize6 div-horizontal">
                                                                <input defaultValue={bet.sau.split(" ")[2]} min="100" max="999" name="sau3" style={{ width: "60px" }} value={numbers[22] == null ? bet.sau.split(" ")[2] : numbers[22]} onChange={(e) => handleInputChange(e, 22)} />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th>7</th>
                                                        <td>
                                                            <span id="mb_prize_23" className="prize7 div-horizontal">
                                                                <input defaultValue={bet.bay.split(" ")[0]} min="10" max="99" name="bay1" style={{ width: "60px" }} value={numbers[23] == null ? bet.bay.split(" ")[0] : numbers[23]} onChange={(e) => handleInputChange(e, 23)} />
                                                            </span>
                                                            <span id="mb_prize_24" className="prize7 div-horizontal">
                                                                <input defaultValue={bet.bay.split(" ")[1]} min="10" max="99" name="bay2" style={{ width: "60px" }} value={numbers[24] == null ? bet.bay.split(" ")[1] : numbers[24]} onChange={(e) => handleInputChange(e, 24)} />
                                                            </span>
                                                            <span id="mb_prize_25" className="prize7 div-horizontal">
                                                                <input defaultValue={bet.bay.split(" ")[2]} min="10" max="99" name="bay3" style={{ width: "60px" }} value={numbers[25] == null ? bet.bay.split(" ")[2] : numbers[25]} onChange={(e) => handleInputChange(e, 25)} />
                                                            </span>
                                                            <span id="mb_prize_26" className="prize7 div-horizontal">
                                                                <input defaultValue={bet.bay.split(" ")[3]} min="10" max="99" name="bay4" style={{ width: "60px" }} value={numbers[26] == null ? bet.bay.split(" ")[3] : numbers[26]} onChange={(e) => handleInputChange(e, 26)} />
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div>{t('waiting')}</div>
                                        )}
                                    </div>
                                    <br />
                                    <button
                                        type="button"
                                        onClick={generateRandomNumbers}
                                        className="btn-submit btn-admin-1"
                                        style={{ display: "inline-block", margin: "0 0 0 10px" }}>
                                        {t('random')}
                                    </button>
                                    <button type="submit" className="btn-submit btn-admin-3" style={{ display: "inline-block", margin: "0 0 0 10px", padding: "7px 12px" }}>
                                        {t('submit')}
                                    </button>
                                    <button
                                        type="button"
                                        style={{ display: "inline-block", margin: "0 0 0 10px" }}
                                        className="btn-submit btn-admin-2"
                                        onClick={() => {
                                            window.location.reload(true);
                                        }}>
                                        {t('refresh')}
                                    </button>
                                </form>
                                
                                <div
                                    style={{
                                        flex: 1,
                                        textAlign: "center",
                                        width: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        marginTop: "50px",
                                        color: "white",
                                        backgroundColor: "#121828",
                                        justifyContent: "space-between"
                                    }}>
                                    <h1>{t('session')} {listEdit}</h1>
                                    <select onChange={handleChange} value={listEdit}>
                                        {list30
                                            ? list30.map((item, idx) => {
                                                  return <option key={idx} value={item?.id_bet}>{t('session')} {item?.id_bet}</option>;
                                              })
                                            : null}
                                    </select>
                                </div>
                                {newChange && (
                                    <>
                                        <form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                const formData = {
                                                    id_bet: newChange._id,
                                                    dacbiet: e.target.dacbiet.value,
                                                    nhat: e.target.nhat.value,
                                                    hai: e.target.hai1.value + " " + e.target.hai2.value,
                                                    ba:
                                                        e.target.ba1.value +
                                                        " " +
                                                        e.target.ba4.value +
                                                        " " +
                                                        e.target.ba2.value +
                                                        " " +
                                                        e.target.ba3.value +
                                                        " " +
                                                        e.target.ba5.value +
                                                        " " +
                                                        e.target.ba6.value,
                                                    tu: e.target.tu1.value + " " + e.target.tu2.value + " " + e.target.tu3.value + " " + e.target.tu4.value,
                                                    sau: e.target.sau1.value + " " + e.target.sau2.value + " " + e.target.sau3.value,
                                                    bay: e.target.bay1.value + " " + e.target.bay2.value + " " + e.target.bay3.value + " " + e.target.bay4.value,
                                                    nam:
                                                        e.target.nam1.value +
                                                        " " +
                                                        e.target.nam2.value +
                                                        " " +
                                                        e.target.nam3.value +
                                                        " " +
                                                        e.target.nam4.value +
                                                        " " +
                                                        e.target.nam5.value +
                                                        " " +
                                                        e.target.nam6.value
                                                };
                                                axios
                                                    .post(`${process.env.REACT_APP_API_URL}/xs75s/update`, formData)
                                                    .then((res) => {
                                                        swal(t('success'), "", "success").then(() => {
                                                            window.location.reload();
                                                        });
                                                    })
                                                    .catch((res) => swal(t('error'), "", "error"));
                                            }}>
                                            <div style={{ color: "black", marginTop: '20px' }} className="result_admin_choose">
                                                <table id="table-xsmb" className="table-result table table-bordered table-striped table-xsmb">
                                                    <tbody>
                                                        <tr>
                                                            <th style={{ width: "10%" }}>ĐB</th>
                                                            <td>
                                                                <span id="mb_prize_0" className="special-prize div-horizontal">
                                                                    <input defaultValue={newChange.dacbiet} min="10000" max="99999" name="dacbiet" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>1</th>
                                                            <td>
                                                                <span id="mb_prize_1" className="prize1 div-horizontal">
                                                                    <input defaultValue={newChange.nhat} name="nhat" min="10000" max="99999" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>2</th>
                                                            <td>
                                                                <span id="mb_prize_2" className="prize2 div-horizontal">
                                                                    <input defaultValue={newChange.hai.split(" ")[0]} name="hai1" min="10000" max="99999" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_3" className="prize2 div-horizontal">
                                                                    <input defaultValue={newChange.hai.split(" ")[1]} name="hai2" min="10000" max="99999" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>3</th>
                                                            <td>
                                                                <span id="mb_prize_4" className="prize3 div-horizontal">
                                                                    <input defaultValue={newChange.ba.split(" ")[0]} min="10000" max="99999" name="ba1" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_5" className="prize3 div-horizontal">
                                                                    <input defaultValue={newChange.ba.split(" ")[1]} min="10000" max="99999" name="ba2" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_6" className="prize3 div-horizontal">
                                                                    <input defaultValue={newChange.ba.split(" ")[2]} min="10000" max="99999" name="ba3" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_7" className="prize3 div-horizontal">
                                                                    <input defaultValue={newChange.ba.split(" ")[3]} min="10000" max="99999" name="ba4" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_8" className="prize3 div-horizontal">
                                                                    <input defaultValue={newChange.ba.split(" ")[4]} min="10000" max="99999" name="ba5" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_9" className="prize3 div-horizontal">
                                                                    <input defaultValue={newChange.ba.split(" ")[5]} min="10000" max="99999" name="ba6" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>4</th>
                                                            <td>
                                                                <span id="mb_prize_10" className="prize4 div-horizontal">
                                                                    <input defaultValue={newChange.tu.split(" ")[0]} min="1000" max="9999" name="tu1" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_11" className="prize4 div-horizontal">
                                                                    <input defaultValue={newChange.tu.split(" ")[1]} min="1000" max="9999" name="tu2" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_12" className="prize4 div-horizontal">
                                                                    <input defaultValue={newChange.tu.split(" ")[2]} min="1000" max="9999" name="tu3" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_13" className="prize4 div-horizontal">
                                                                    <input defaultValue={newChange.tu.split(" ")[3]} min="1000" max="9999" name="tu4" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>5</th>
                                                            <td>
                                                                <span id="mb_prize_14" className="prize5 div-horizontal">
                                                                    <input defaultValue={newChange.nam.split(" ")[0]} min="1000" max="9999" name="nam1" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_15" className="prize5 div-horizontal">
                                                                    <input defaultValue={newChange.nam.split(" ")[1]} min="1000" max="9999" name="nam2" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_16" className="prize5 div-horizontal">
                                                                    <input defaultValue={newChange.nam.split(" ")[2]} min="1000" max="9999" name="nam6" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_17" className="prize5 div-horizontal">
                                                                    <input defaultValue={newChange.nam.split(" ")[3]} min="1000" max="9999" name="nam3" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_18" className="prize5 div-horizontal">
                                                                    <input defaultValue={newChange.nam.split(" ")[4]} min="1000" max="9999" name="nam4" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_19" className="prize5 div-horizontal">
                                                                    <input defaultValue={newChange.nam.split(" ")[5]} min="1000" max="9999" name="nam5" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>6</th>
                                                            <td>
                                                                <span id="mb_prize_20" className="prize6 div-horizontal">
                                                                    <input defaultValue={newChange.sau.split(" ")[0]} min="100" max="999" name="sau1" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_21" className="prize6 div-horizontal">
                                                                    <input defaultValue={newChange.sau.split(" ")[1]} min="100" max="999" name="sau2" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_22" className="prize6 div-horizontal">
                                                                    <input defaultValue={newChange.sau.split(" ")[2]} min="100" max="999" name="sau3" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>7</th>
                                                            <td>
                                                                <span id="mb_prize_23" className="prize7 div-horizontal">
                                                                    <input defaultValue={newChange.bay.split(" ")[0]} min="10" max="99" name="bay1" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_24" className="prize7 div-horizontal">
                                                                    <input defaultValue={newChange.bay.split(" ")[1]} min="10" max="99" name="bay2" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_25" className="prize7 div-horizontal">
                                                                    <input defaultValue={newChange.bay.split(" ")[2]} min="10" max="99" name="bay3" style={{ width: "60px" }} />
                                                                </span>
                                                                <span id="mb_prize_26" className="prize7 div-horizontal">
                                                                    <input defaultValue={newChange.bay.split(" ")[3]} min="10" max="99" name="bay4" style={{ width: "60px" }} />
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br />
                                                <button
                                                    type="submit"
                                                    className="btn-submit btn-admin-1"
                                                    style={{
                                                        display: "inline-block",
                                                        margin: "0 0 0 10px"
                                                    }}>
                                                    {t('submit')}
                                                </button>
                                                <button
                                                    type="button"
                                                    style={{
                                                        display: "inline-block",
                                                        margin: "0 0 0 10px"
                                                    }}
                                                    className="btn-submit btn-admin-2"
                                                    onClick={() => {
                                                        window.location.reload(true);
                                                    }}>
                                                    {t('refresh')}
                                                </button>
                                            </div>
                                        </form>
                                    </>
                                )}
                            </Container>
                        </Box>
                    ) : (
                        <div>{t('not_permission')}</div>
                    )}
                </DashboardLayout>
            </ThemeProvider>
        </>
    );
}

export default SetXoSo;
